import { Action, createReducer, on } from '@ngrx/store';

import { Customization } from './model/customization.model';
import { CustomizationActions } from './customization.actions';

export const customizationFeatureKey = 'customization';

export interface State {
    customization: Customization | null;
}

export const initialState: State = {
    customization: null
};

const customizationReducer = createReducer(
    initialState,
    on(CustomizationActions.setCustomization, CustomizationActions.loadCustomizationSuccess, (state, { customization }) => {
        return {
            ...state,
            customization
        };
    })
);

export function reducer(state: State | undefined, action: Action) {
    return customizationReducer(state, action);
}
